import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtmFromUrl } from "@/lib/utm";
import { loadTrackingScripts, trackPageView } from "@/lib/analytics";

/**
 * Mounts once inside the Router. On every route change it:
 *  - captures any utm_* params into sessionStorage (so signup/enquiry
 *    handlers downstream can attribute the conversion to the campaign);
 *  - loads GA4/Meta Pixel scripts on first consented navigation;
 *  - fires a page_view to GA4 + PageView to Meta.
 *
 * All vendor calls are gated on cookie consent inside analytics.ts.
 */
export function TrackingProvider() {
  const location = useLocation();

  useEffect(() => {
    captureUtmFromUrl();
    loadTrackingScripts();
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
